import React from "react";
import styles from "./Edit.module.css";
import AmpCheckBox from "../../common/AmpCheckBox/AmpCheckBox";
import { UserProperty } from "../../../redux/reducers/getPropertySelectionListReducer/propertySelectionListReducer";
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";
import { useTranslation } from "react-i18next";
import { EnotifPendingChange } from "../../../redux/actions/enotif/enotif";

export interface EditRowProps {
    pendingValue: EnotifPendingChange | undefined;
    enotifNotAllowed: boolean;
    index: string;
    enotifValue: boolean;
    handleEnotifChange: (property: UserProperty, checked: boolean) => void;
    property: UserProperty;
    enotifAria: string;
    isPreview: boolean | undefined
}

export default function EditRow(props: EditRowProps) {

    const { t } = useTranslation(["login", "propertySelectionList", "property"]);
    
    return (
        <div className={`${styles.EditRow} ${props.pendingValue && styles.Pending} ${props.enotifNotAllowed && styles.NotAllowed}`} key={props.index}>
            <span>
                <AmpCheckBox defaultChecked={props.enotifValue || false} isSlider={true} handleCheck={(e: React.ChangeEvent<HTMLInputElement>) => { props.handleEnotifChange(props.property, e.currentTarget?.checked) }} id={props.enotifAria} label={""} hasToolTip={undefined} toolTip={""} disabled={props.enotifNotAllowed || props.isPreview} />
                {props.enotifNotAllowed && <div className={styles.EnotifTip}><AmpToolTip size="lg" textDirection={"left-text"} id={`${props.index}${props.enotifAria}`} content={t("enotif-not-allowed")} direction="right" /></div>}
            </span>
            <div>{props.property.roll_num}</div>
            <div>{props.property.address}</div>
        </div>
    )
}